import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

// Attach JWT on every request (if available)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cravve-token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Token invalid/expired — clear and let UI handle
      localStorage.removeItem("cravve-token");
      localStorage.removeItem("cravve-role");
    }
    return Promise.reject(err);
  }
);

export default api;
